import { useMemo } from 'react';
import { useGetList, useGetOne } from 'react-admin';
import { DataStats } from "../../models/data-stats";
import { GlobalMapFilter } from '../../components/global-map-filter/global-map-filter';
import { TransactionsDataMap } from './components/transactions-data-map';
import { TransactionDataDto, TransactionsDataDistribution } from '../../models/transactions-data';
import { useDateRange } from '../../hooks/use-date-range';
import { useMapAttributeType } from '../../hooks/use-map-attribute';


const styles = {
  flex: { display: 'flex' },
  flexColumn: { display: 'flex', flexDirection: 'column' },
  leftCol: { flex: 1, },
  rightCol: { flex: 6, marginLeft: '0.5em' },
  singleCol: { marginTop: '0.5em', marginBottom: '0.5em' },
};

export type DataFilter = {
  type: 'sale' | 'rent';
  from: string,
  to: string;
}

export const TransactionsMapPage = () => {
  const [fromDate, toDate] = useDateRange();
  const [mapAttributeType] = useMapAttributeType();

  const dataFilter = useMemo<DataFilter>(() => {
    return {
      type: mapAttributeType.toString(),
      from: fromDate,
      to: toDate
    } as DataFilter;
  }, [fromDate, toDate, mapAttributeType]);

  const { data, isLoading } = useGetList<TransactionDataDto>('data/transactions', {
    filter: { 
      type: dataFilter.type, 
      from: dataFilter.from, 
      to: dataFilter.to 
    },
  });

  const dataDistribution = useMemo<TransactionsDataDistribution>(() => {
    if (!data) return {};
    const aggregations = data
      .reduce(
        (stats: DataStats, data) => {
          if (stats.dataMin > data.dataMean)
            stats.dataMin = data.dataMean;
          if (stats.dataMax < data.dataMean)
            stats.dataMax = data.dataMean;
          if (data.dataCount > stats.dataCountMax)
            stats.dataCountMax = data.dataCount;
          stats.dataMean += data.dataMean;
          return stats;
        },
        {
          dataMin: data[0]?.dataMean ?? 0,
          dataMax: 0,
          dataMean: 0,
          dataCountMax: 0
        }
      );
    aggregations.dataMean /= data.length;

    // const aggregations = {
    //   dataMin: data[0]?.dataMin ?? 0,
    //   dataMax: 0,
    //   dataMean: 0,
    //   dataCountMax: 0
    // };
    return {
      data: data,
      stats: aggregations
    };
  }, [data]);

  return (
    <>
      <GlobalMapFilter dataStats={dataDistribution.stats!} mapDataType='transactions' />
      <div style={styles.flex}>
        {/* <div style={styles.leftCol}>
          <div style={styles.singleCol}>
            <SchoolsFilter />
          </div>
        </div> */}
        <div style={styles.rightCol}>
          <div style={styles.singleCol}>
            <TransactionsDataMap dataDistribution={dataDistribution} />
          </div>
        </div>
      </div>
    </>
  );
};
